import getGlobalStacks from "@/state/globalStacks";
import Hammer from "hammerjs";
import { useEffect, useRef } from "react";

export function useSwipeRef() {
  const swipeRef = useRef(null);

  const handleSwipe = (direction: "left" | "right") => {
    // Goes through HGStacks rather than the raw stack: shifting the stack
    // directly skips the notify, so nothing re-rendered, no min/max was
    // re-derived and sessionStorage/title/history were never updated.
    // Nudges whichever endpoint the picker is focused on, so a range can be
    // adjusted by swiping instead of being a reason to do nothing.
    getGlobalStacks().shiftFocused(direction === "left" ? 1 : -1);
  };

  useEffect(() => {
    if (!swipeRef.current) return;
    const hammer = new Hammer(swipeRef.current);

    hammer.on("swipeleft", async () => {
      handleSwipe("left");
    });

    hammer.on("swiperight", async () => {
      handleSwipe("right");
    });

    return () => {
      hammer.destroy();
    };
    // Deliberately `[]`, not `[swipeRef.current]`: mutating a ref doesn't
    // trigger a re-render, so that dependency would be read during render
    // before the ref attaches, and this effect would never actually run.
    // Reading `.current` inside the effect body works because effects run
    // after refs are attached.
  }, []);

  return swipeRef;
}
